module.exports = __webpack_public_path__ + "static/media/Trading_Up_Tablet_Banner_STAKE@1x.8f04178c.webp";